import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class AboutDrive {
    static init(el){
        const aboutDriveElm = el.detail.element.querySelector('[data-about-drive]');
        new AboutDrive(aboutDriveElm);
    }

    constructor(aboutDriveElm) {
        if(!aboutDriveElm) {
            return;
        }

        const triggerElm = aboutDriveElm.querySelector('[data-about-drive-trigger]');
        const images = triggerElm.querySelectorAll('.img');
        const textElms = triggerElm.querySelectorAll('.c-scrollbox__text');

        let mm = gsap.matchMedia();
        mm.add("(min-width: 992px)", () => {

            const imgHeight = images[0].scrollHeight;
            const end = imgHeight*3;

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: triggerElm,
                    start: "center center",
                    end: '+='+end,
                    pin: triggerElm,
                    anticipatePin: true,
                    scrub: true
                }
            });

            const showText = (index) => {

                const direction = tl.scrollTrigger.direction;
                let nextIndex = index;
                if(direction===-1) {
                    nextIndex = index-1;
                }

                textElms.forEach((text, index) => {
                    gsap.killTweensOf(text);
                    if(index===nextIndex) {
                        gsap.to(text, {
                            opacity: 1,
                            duration: 0.6,
                            delay: 0.3,
                            ease: 'sine.inOut'
                        });
                    } else {
                        gsap.to(text, {
                            opacity: 0,
                            duration: 0.3,
                            delay: 0,
                            ease: 'sine.inOut'
                        });
                    }
                });
            }

            tl.to(images[1], {
                x: '0%',
                ease: 'none',
                duration: 1
            })
            tl.addLabel("end2")
            .call(showText, [1], '<50%')
            .fromTo(images[0].children[0], {
                opacity: 1,
            }, {
                opacity: 0.25,
                ease: 'none',
                duration: 1
            }, 'end2-=100%')
            .to(images[2], {
                x: '0%',
                ease: 'none',
                duration: 1
            })
            tl.addLabel("end3")
            .call(showText, [2], '<50%')
            .fromTo(images[1].children[0], {
                opacity: 1,
            }, {
                opacity: 0.25,
                ease: 'none',
                duration: 1
            }, 'end3-=100%')
            tl.to(images[0].children[0], {
                opacity: 0,
                duration: 1
            })
        });

    }
}
